<div class="image-block">
    <img [src]="url" (error)="updateUrl()">
</div>
